export default {"src":"/_next/static/media/MobileApp.30f5ce83.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};